import { useEffect, useState } from 'react';

type TUseOsTypeReturn = [string];

const useOsType = (): TUseOsTypeReturn => {
  const [osType, setOsType] = useState('');

  useEffect(() => {
    let isIos: boolean;
    if (navigator.userAgent) {
      isIos = /iphone|ipad|ipod/gi.test(navigator.userAgent);
      setOsType(isIos ? 'IOS' : 'AND');
    }
  }, []);

  return [osType];
};

export default useOsType;
